import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddHtmlDocFile = () => {
  const navigate = useNavigate();
  const { id, name } = useParams(); // Get the HTML document ID from the URL

  // State to hold form data
  const [formData, setFormData] = useState({
    HtmlDocId: id,
    Remark: "",
    Active: true,
    Name: name,
    File: null,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(null); // 'success' | 'error'

  // State for selected name from select box
  const [selectedName, setSelectedName] = useState("");

  // Handle input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "File") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    // Validation
    if (!formData.Remark || !formData.File || !selectedName) {
      setMessage("Please fill in all required fields including name selection.");
      setMessageType("error");
      return;
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    // Create a new FormData object
    const data = new FormData();

    data.append("HtmlDocId", formData.HtmlDocId);
    data.append("Remark", formData.Remark);
    data.append("Active", formData.Active);
    data.append("Name", selectedName);
    data.append("File", formData.File);

    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/SubUser/Insert',
        data,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response.data);

      const resp = response && response.data;
      const isSuccess =
        (resp && resp.isresponse === true) ||
        (resp && typeof resp.responsestatus === "string" && resp.responsestatus.toUpperCase() === "SUCCESS");

      const rawMsg =
        (resp && (resp.errormsg || resp.message || resp.Message || resp.responsestatus)) ||
        "";
      const apiMessage = typeof rawMsg === "string" ? rawMsg : JSON.stringify(rawMsg);

      setMessage(apiMessage || (isSuccess ? "Operation completed successfully." : "Operation finished."));
      setMessageType(isSuccess ? "success" : "error");

      if (isSuccess) {
        setTimeout(() => {
          navigate(`/showhtmldoc/${id}/${name}`);
        }, 3000);
      }
    } catch (error) {
      const errData = error && error.response && error.response.data;
      const errRaw =
        (errData && (errData.errormsg || errData.message || errData.Message || errData.responsestatus)) ||
        (error && error.message) ||
        "Failed to add HTML document file.";
      const errorMessage = typeof errRaw === "string" ? errRaw : JSON.stringify(errRaw);
      setMessage(errorMessage);
      setMessageType("error");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper add-html-doc-file-page">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info elevated-card">
                    <div className="card-header">
                      <h3 className="card-title">Add HTML Document File</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group"></div>
                            <div className="form-group">
                              <label>Select Name</label>
                              <select
                                className="form-control input-lg"
                                value={selectedName}
                                onChange={(e) => setSelectedName(e.target.value)}
                                name="Name"
                              >
                                <option value="">-- Select Name --</option>
                                <option value="welcome">Welcome</option>
                                <option value="billtotal">Bill Total</option>
                                <option value="qrcode">QR Code</option>
                                <option value="success">Success</option>
                                <option value="fail">Fail</option>
                                <option value="pending">Pending</option>
                                <option value="cancel">Cancel</option>
                                <option value="itemdetails">Item Details</option>
                                <option value="bill">Bill</option>
                              </select>
                            </div>
                            <div className="form-group">
                              <label>File Description</label>
                              <input
                                type="text"
                                className="form-control input-lg"
                                value={formData.Remark}
                                onChange={handleChange}
                                placeholder="Enter file description..."
                                name="Remark"
                              />
                            </div>
                            <div className="form-group">
                              <label>Upload File</label>
                              <input
                                type="file"
                                className="form-control input-lg"
                                onChange={handleChange}
                                name="File"
                                accept="image/*,.html,text/html"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info btn-lg"
                          >
                            Add File
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="page-messages">
        {message && messageType === "success" ? <SuccessMessage message={message} /> : ""}
        {message && messageType === "error" ? <FailedMessage message={message} /> : ""}
      </div>
    </>
  );
};

export default AddHtmlDocFile;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}